import React from 'react';

import { css } from '@emotion/css';
import { colors } from 'theme/colors';

import { FlexSpace } from 'components/FlexSpace';

export const StatusTile = ({
  icon,
  title,
  data,
  description,
}: {
  icon: JSX.Element;
  title: string;
  data: string;
  description: string;
}) => (
  <div
    className={css`
      background-color: ${colors.neutral[100]};
      border-radius: 12px;
      padding-top: 16px;
      padding-bottom: 16px;
      width: 33%;
    `}
  >
    <FlexSpace direction="column">
      <FlexSpace
        direction="row"
        gap={8}
        className={css`
          padding-left: 16px;
        `}
      >
        {icon}
        <div
          className={css`
            font-size: 16px;
            font-weight: bold;
          `}
        >
          {title}
        </div>
      </FlexSpace>
      <div
        className={css`
          font-size: 32px;
          font-weight: bold;
          padding-left: 48px;
          color: ${colors.neutral[700]};
        `}
      >
        {data}
      </div>
      <div
        className={css`
          font-size: 16px;
          padding-left: 48px;
          color: ${colors.neutral[700]};
        `}
      >
        {description}
      </div>
    </FlexSpace>
  </div>
);
